import React, {useState} from "react";
import {Link, useLocation, Route, Switch} from "react-router-dom";
import IndividualQuoter from "../../pages/Quoter/IndividualQuoter";
import Emission from "../../pages/Emission/Emission";
import './Sidebar.css';
import Navbar from "../Navbar/Navbar";
import Consult from "../../pages/Consultation/Consult";
import PaymentGateway from "../../pages/Payment/PaymentGateway";
import {enableBanjercito} from "../../index";
import {handleLogout} from "../../services/auth-service";
import ProtectedRoute from "../../ProtectedRoute";
import Requoter from "../Requoter/Requoter";
import pwdSekura from "@images/POWERED BY SEKURA LOGO.svg";
import Login from "../../pages/Login/Login";

export default function Sidebar(props) {

    const isAuthenticated = localStorage.getItem("isAuthenticated");
    let location = useLocation();

    let [showSidebar, setShowSidebar] = useState(false);
    let toggleShowSidebar = () => { //Toggle to show or hide SideBar.
        setShowSidebar(!showSidebar);
    };
    return (
        <div>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto menu bg-skrPrimary border-end montserratMedium m-0 p-0"
                         hidden={showSidebar || location.pathname === '/cotizador' || location.pathname === '/login'}>
                        <div
                            className="d-flex flex-column align-items-center m-0 p-0 align-items-sm-start text-white min-vh-100">
                            <ul className="nav flex-column m-0 p-0 mt-4"
                                id="menu">
                                <Link to="/cotizadorAdministrador">
                                <li className="nav-item shrink">
                                             <div
                                                 className="item mt-5">Cotizador</div>
                                </li>
                                </Link>
                                <Link to="/consulta">
                                <li className="nav-item shrink" hidden={props.userPermissions[0] !== 1}>
                                             <div
                                                 className="item">Consulta</div>
                                </li>
                                </Link>
                                <li className="nav-item shrink" onClick={handleLogout} role="button">
                                             <div
                                                 className="item">Salir</div>
                                </li>
                                <li>
                                    <img src={pwdSekura} className="item img-fluid fixed-bottom mb-4" alt="Powered by Sekura"/>
                                </li>
                            </ul>
                            <hr/>
                        </div>
                    </div>
                    <div className="col w-75 content m-0 p-0">
                        <h3 onClick={toggleShowSidebar}
                            className="menu-btn position-absolute mt-2
                                btn-outline-secondary rounded mx-2 px-2 p-0"
                            role="button"
                            hidden={!isAuthenticated || location.pathname === '/cotizador' || location.pathname === '/login'}
                            data-toggle="tooltip"
                            title="Mostrar/Ocultar Menú">
                            <i className="bi-list"></i>
                        </h3>

                        <Switch>
                            {/**
                            {!enableBanjercito ?
                                <Route exact path="/" render={() => {
                                    return (
                                        <Redirect to="/cotizador"/>
                                    )
                                }}/> :
                                <Route exact path="/" render={() => {
                                    handleLogout();
                                    return (
                                        <Redirect to="/login"/>
                                    )
                                }}/>}
                            {!enableBanjercito ?
                                <Route exact path="/cotizador" render={() => {
                                    handleLogout();
                                    return (
                                        <>
                                            <Navbar/>
                                            <IndividualQuoter userPermissions={props.userPermissions}/>
                                        </>)
                                }}/> : null}
                             **/}                        
                                            <Route path="/login" component={Login}/>
                            <Route path="/cotizador" render={() => {
                                return (<IndividualQuoter userPermissions={props.userPermissions}/>)
                            }}/>
                            <ProtectedRoute path="/cotizadorAdministrador" component={IndividualQuoter}
                                            userPermissions={props.userPermissions}/>
                            <ProtectedRoute path="/consulta" component={Consult}
                                            userPermissions={props.userPermissions}/>
                            <ProtectedRoute path="/emision=private/:companyId/:movementId/:cp/:paymentId" component={Emission}
                                            userPermissions={props.userPermissions}/>
                            <ProtectedRoute path="/pasarelaPago/:receiptId" component={PaymentGateway}
                                            userPermissions={props.userPermissions}/>
                            <Route path="/emision=public/:companyId/:movementId/:cp/:paymentId" render={() => {
                                return (
                                    <>
                                        <Navbar/>
                                        <Emission/>
                                    </>)
                            }}/>
                            <Route path="/recotizar/:movementId" render={() => {
                                return (
                                    <>
                                        <Navbar/>
                                        <Requoter/>
                                    </>)
                            }}/>
                            <Route path="*" render={() => {
                                handleLogout()
                            }}/>                        
                        </Switch>

                    </div>
                </div>
            </div>
        </div>
    )
}